import { createContext, useContext, type ReactNode } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { ROUTES } from '@/routes/helpers/paths';

export type CompanyFetchMode = 'general' | 'spotlight';

const CompanyFetchContext = createContext<CompanyFetchMode>('general');

export const CompanyFetchProvider = ({
  children,
  mode,
}: {
  children: ReactNode;
  mode: CompanyFetchMode;
}) => (
  <CompanyFetchContext.Provider value={mode}>
    {children}
  </CompanyFetchContext.Provider>
);

export const useCompanyFetchMode = (): CompanyFetchMode => {
  const contextMode = useContext(CompanyFetchContext);
  const { pathname } = useLocation();

  if (contextMode !== 'general') {
    return contextMode;
  }

  return matchPath(ROUTES.spotlightCompany, pathname) ? 'spotlight' : 'general';
};

export const useIsSpotlightCompanyView = (): boolean =>
  useCompanyFetchMode() === 'spotlight';
